import NumberFormat from 'react-number-format'
import { useCardContext } from '../../hooks/useCardContext'
export default function CardList() {
	const { value } = useCardContext()

	return (
		<div className='flex items-center'>
			<div className='m-2 relative bg-white p-5 rounded-md shadow-md'>
				<div className='w-60 border my-5 p-2'>
					<p>{!value.length ? 'No ' : value.length} cards listed</p>
				</div>
				<div className='flex space-x-12 text-sm'>
					<p>Country</p>
					<p>Card Holder</p>
					<p>Card Number</p>
					<p>Expiry Date</p>
				</div>
				{value &&
					value.map(card => (
						<div
							className='textfield flex space-x-4 justify-between text-xs'
							key={card.cardNumber}>
							<p>{card.country}</p>
							<p>{card.cardHolder}</p>
							<NumberFormat
								displayType={'text'}
								format='#### #### #### ####'
								value={card.cardNumber}
							/>
							<div className='flex'>
								<p>{card.expiryMonth}</p>
								<p>/</p>
								<p>{card.expiryYear}</p>
							</div>
						</div>
					))}
				<p className='pt-5 text-gray-500 my-2 text-xs'>
					{'< prev'}
					<span className='px-2 mx-1 rounded-sm text-white bg-gray-400'>1</span>
					{'next >'}
				</p>
			</div>
		</div>
	)
}
